import type { Component } from 'vue'

import { IconGift } from '@ds/icons/IconGift'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconShop } from '@ds/icons/IconShop'
import { IconSmartphone } from '@ds/icons/IconSmartphone'
import { IconSparkles } from '@ds/icons/IconSparkles'
import { IconTradeIn } from '@ds/icons/IconTradeIn'

const NAV_ICON_MAP: Record<string, Component> = {
  Sparkles: IconSparkles,
  Swap: IconTradeIn,
  IconGift,
  Shop: IconShop,
  Quality: IconQuality,
  Smartphone: IconSmartphone,
}

export function resolveNavIcon(iconName: string): Component | undefined {
  return NAV_ICON_MAP[iconName]
}

export function resolveServiceIcon(iconName: string): Component {
  return iconName === 'trade-in' ? IconTradeIn : IconSparkles
}
